module.exports = __webpack_public_path__ + "static/media/invoicePdf.0b2bda48.svg";